import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import Loading from "../Loading";
import JobList from "../jobs/JobList";
import JobDetails from "../jobs/details/JobDetails";
import ServerList from "./ServerList";
import ServerEditor from "./ServerEditor";


export default function Server() {

    const [selectedServer, setSelectedServer] = useState<string | null>(null);
    const [searchParameters, setSearchParameters] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        if (searchParameters.has('server')) {
            const server = searchParameters.get('server');
            if (server) {
                setSelectedServer(server);
                setLoading(false);
            } else {
                setSelectedServer(null);
                setLoading(false);
            }
        }else{
            setSelectedServer(null);
            setLoading(false);
        }
    }, [searchParameters]);

    return (<>
        <Loading open={loading}></Loading>
        {!loading && !selectedServer && (<ServerList></ServerList>)}
        {!loading && selectedServer && (<ServerEditor serverId={selectedServer}></ServerEditor>)}
    </>);
}